"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERCENTAGE_RATE_SAVED_WITH_FEES = void 0;
exports.PERCENTAGE_RATE_SAVED_WITH_FEES = 5;
